let API;

/**
 * Makes server request for tracking
 *
 * @param eventName - The event name
 * @param data - Tracking data
 */
async function makeRequest(eventName: string, data: any) {
  const body = {
    eventName,
    ...data,
  };

  API = API ?? (await import('@nakedinsurance/aws-titan/dist/lib/api')).API;

  return API.post('analytics', '/segment/identify-track', {
    body,
  }).catch(_e => {
    // Sentry
    return '';
  });
}
export const ServerAnalytics = {
  track: makeRequest,
};
